import { NextSeo } from 'next-seo';
import TheKittiesPage from '../../components/TheKittiesPage';

export default function FirstLitterPage() {
  const title = 'First Litter - Shitty Kitties';
  const description = `Shitty Kitties is an NFT collection on the Algorand blockchain. It's a
          fun collection containing 470 1/1 unique
          shitty drawings resembling a kitty 🐈🤷‍♂️`;

  return (
    <div>
      <NextSeo title={title} description={description} />
      <TheKittiesPage title={'First Litter'} gen={1} />
    </div>
  );
}
